import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDecimalPipe'
})
export class CustomDecimalPipePipe implements PipeTransform {

  transform(value: any): any {
    if(Math.ceil(value) === 0) {
      return 1
    }
    return Math.ceil(value);
  }

}
